module.exports = __webpack_public_path__ + "static/media/image4.711195be.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Indiechef/image4.JPG
// module id = 1171
// module chunks = 0